import { useQuery } from '@tanstack/react-query';
import { fetchSearchResults } from "./endpoints";
export const useSearchResults = (searchQuery, onlyActive) => {
    const { data: searchResults, isLoading, isFetching, isError, refetch, } = useQuery({
        queryKey: ['search', searchQuery, onlyActive],
        queryFn: () => fetchSearchResults(searchQuery, onlyActive),
        enabled: searchQuery.trim() !== '',
        keepPreviousData: true,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
    });
    return {
        searchResults,
        isLoading,
        isFetching,
        isError,
        refetch,
    };
};
